import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";

const AddTransport = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [formdata, setFormData] = useState({
    id: null,
    name: "",
    gst_no: "",
  });

  const onSave = () => {
    if (formdata.name) {
      setError(false);
      setLoading(true);
      const pUrl = id ? API_URL.TRANSPORT_UPDATE : API_URL.TRANSPORT_SAVE;
      axios.post(pUrl, formdata).then((res) => {
        if (res.data.status === 1) {
          let message = id
            ? "Transport Updated Successfully."
            : "Transport Created Successfully.";
          toast.success(message, { autoClose: 3000, position: "top-right" });
          setLoading(false);
          navigate("/settings/transport");
        }
      })
        .finally(() => {
          setLoading(false);
          setError(true);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const onEdit = () => {
    axios.post(API_URL.TRANSPORT_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormData({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          gst_no: res.data.data.gst_no ? res.data.data.gst_no : "",
        });
      }
    });
  };

  const isRequiredField = (key) => {
    return isError && !formdata[key];
  };

  useEffect(() => {
    id && onEdit();
  }, [id]);
  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>{id ? "Edit" : "Add"} Transport</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link
              to={"/settings/transport"}
              className="btn btn-secondary"
            >
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>Name<span className="required-star">*</span></label>
                      <input
                        type="text"
                        name="name"
                        value={formdata.name}
                        className={
                          isRequiredField("name")
                            ? "form-control required"
                            : "form-control"
                        }
                        id="name"
                        onChange={(event) => {
                          setFormData({
                            ...formdata,
                            name: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>GST</label>
                      <input
                        type="text"
                        name="gst_no"
                        value={formdata.gst_no}
                        className="form-control"
                        id="gst_no"
                        onChange={(event) => {
                          setFormData({
                            ...formdata,
                            gst_no: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group text-right">
                    <button
                      type="submit"
                      onClick={onSave}
                      disabled={loading}
                      className="btn btn-primary"
                    >
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Watch color={"white"} height={20} width={20} />
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTransport;
